import React, { useState } from 'react'

import { BUSINESS_EVENT_LABEL_MAP, BUSINESS_EVENT_TYPES_PER_PRESET_ID_MAPPING } from '../../../models/BusinessEvent'
import { AiFeaturePreset } from '../../../models/AiFeaturePreset'

import { BusinessEventIcon } from '../../../components/BusinessEvent/BusinessEventIcon/BusinessEventIcon'
import { useZocksQuota } from '../../../components/ScopedBlock/hooks'

import './AIFeaturePresetBusinessEvents.scss'

interface AIFeaturePresetBusinessEventsProps {
  aiFeaturePreset: AiFeaturePreset
  className?: string
}

export const AIFeaturePresetBusinessEvents: React.FC<AIFeaturePresetBusinessEventsProps> = ({ aiFeaturePreset, className = '' }) => {
  const { hasQuota } = useZocksQuota()

  const businessEventsEnabled = hasQuota('ai.businessEvent.value')

  const [collapsed, setCollapsed] = useState<boolean>(true)

  const businessEventTypes = BUSINESS_EVENT_TYPES_PER_PRESET_ID_MAPPING[aiFeaturePreset.id]

  if (!businessEventsEnabled || !businessEventTypes?.length) {
    return null
  }

  return (
    <div className={`d-flex flex-column gap-2 ${className}`}>
      <div className='d-flex align-items-center gap-1 cursor-pointer' onClick={() => setCollapsed((prev) => !prev)}>
        <BusinessEventIcon />
        <span className='paragraph-extra-small zocks-text-gray-700 text-decoration-underline'>{businessEventTypes.length} possible Client Signals</span>
        <div className='ai-feature-preset-business-events-collapse-icon-wrapper d-flex align-items-center justify-content-center'>
          <i className={`bi ${collapsed ? 'bi-chevron-expand' : 'bi-chevron-contract'} zocks-text-gray-700`} />
        </div>
      </div>
      {!collapsed ? (
        <div className='d-flex align-items-center gap-1 flex-wrap zocks-ps-1.25'>
          {businessEventTypes.map((businessEventType) => (
            <span className='paragraph-extra-small zocks-py-0.125 px-1 ai-feature-preset-business-event-type'>
              {BUSINESS_EVENT_LABEL_MAP[businessEventType]}
            </span>
          ))}
        </div>
      ) : null}
    </div>
  )
}
